export default {
  data() {
    return {
      waitingNumber: 10,
      operateList: ['rename'],
      tipsText: {
        part1: '·Audlences can only receive video and audio from participants.',
        part2: '·Audlences can not provide their own video and audio.',
        part3: '·Audlences can not communicate in the party.'
      }
    };
  },
  props: {
    userInfo: Object
  },
  methods: {
    operateCallback() {}
  }
};